export {
  RestrictionTypePremium,
  restrictionValidator
}

const RestrictionTypePremium = 'premium'

function restrictionValidator(val) {
  return (
    [RestrictionTypePremium, ''].indexOf(val) >
    -1
  )
}
